import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "infotext-view"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "literatur-title" }, "LITERATUR:", -1)
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!

  return (_openBlock(), _createBlock(_component_ion_col, {
    "size-xs": "12",
    "size-sm": "12",
    "size-md": "12",
    "size-lg": "5"
  }, {
    default: _withCtx(() => [
      (_ctx.infotext)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: "infotext-view",
            innerHTML: _ctx.infotext.description.replace('http://backend.thingtag.at','https://backend.thingtag.at')
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_button, {
        expand: "block",
        color: "thing-tag",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTagging(_ctx.workObjectId)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.infotext?.title) + " taggen ", 1)
        ]),
        _: 1
      }),
      (_ctx.infotext?.literatur)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "literature",
              innerHTML: _ctx.infotext.literatur
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}